const Colors = {
  headerColor: '#212121',
  primaryColor: '#424242',
  accentColor: '#E2E2E2',
  loginPrimaryColor: '#222222',
  loginLigthenPrimaryColor: '#676767',
  loginDarkenPrimaryColor: '#111111',
  white: '#FFFFFF',
  lightGray: '#E8E8E8',
  mediumLightGray: '#c3c3c3',
  gray: '#AAA',
  textColor: '#212121',
  hover: '#ba103d',
  transparentFormColor: '#FFFFFF66',
  transparentOpaqueFormColor: '#FFFFFFAA',
  titleColor: '#424242',
  // green: '#26D07C',
  green: '#61BA79',
  red: '#EA4335',
  // red: '#BA0C2F',
  pastelRed: '#DD6B64',
  // orange: '#FF7500',
  orange: '#EB8C00',
  compliancePurple: '#B444EC',
  rhBlue: '#3498db',
  prussianBlue: '#003153',
  yellow: '#FEDB00',
  googleYellow: '#FBBC05',
  blue: '#6494E4',
  darkBlue: '#5284D2',
  waitingGray: '#AAA',
  info: '#1f77b4',
  warning: '#ff7f0e',
  success: '#2ca02c',
  danger: '#d62728',
  purple: '#9467bd',
  approved: '#00cc00',
  reproved: '#ff0000',
  dataLoadErrorIcon: '#667085',
}

export const chartColors = {
  slaAnalytics: [Colors.warning, Colors.purple, Colors.danger, Colors.success],
  finishedReviews: [Colors.approved, Colors.reproved],
  approvedApplications: [Colors.approved, Colors.info],
  reprovedApplications: [Colors.warning, Colors.reproved],
  approvalStats: [Colors.approved, Colors.info, Colors.reproved],
}


export default Colors
